<template>
    <Modal :close_button="true" :size="'modal-md'" mid="manage-inventory-location">
        <template v-slot:header>
            <span v-if="location && location.id">{{$t('management_console.workplace_modal.edit_title')}}</span>
            <span v-else>{{$t('management_console.workplace_modal.create_title')}}</span>
        </template>
        <template v-slot:body>
            <div class="row mb-3">
                <div class="col">
                    <label class="form-label fw-bold">{{$t('management_console.common.name')}}<span class="ms-1 text-red-500">*</span></label>
                    <input v-model="form.name" type="text" class="form-control form-control-lg" :placeholder="$t('management_console.workplace_modal.name_placeholder')" :aria-label="$t('management_console.common.name')">
                    <small class="d-block mt-1 mb-2" v-html="$t('management_console.workplace_modal.name_help')"></small>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col">
                    <label class="form-label fw-bold">{{$t('management_console.common.address')}}</label>
                    <input v-model="form.address" type="text" class="form-control" :placeholder="$t('management_console.workplace_modal.address_placeholder')" :aria-label="$t('management_console.common.address')">
                    <small class="d-block mt-1 mb-2">{{$t('management_console.workplace_modal.address_help')}}</small>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col">
                    <label class="form-label fw-bold">{{$t('management_console.common.phone')}}</label>
                    <input v-model="form.phone" type="text" class="form-control" placeholder="1234567890" :aria-label="$t('management_console.common.phone')">
                    <small class="d-block mt-1 mb-2">{{$t('management_console.workplace_modal.phone_help')}}</small>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <small><span class="text-red-500">*</span> {{$t('console.fields_are_mandatory')}}</small>
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <button :disabled="!valid_form && !loading" type="button" class="btn btn-primary bg-gradient px-4" @click="submit()">
                <span v-if="location && location.id">{{$t('controls.update')}}</span>
                <span v-else>{{$t('controls.create')}}</span>
            </button>
            <button type="button" class="btn px-4" @click="cancel()">{{$t('controls.cancel')}}</button>
        </template>
    </Modal>
</template>

<script>
import InventoryLocationStore from '@/common/store/inventory_location.js'

export default {
    props: {
        location: {
            type: Object,
            default: () => {}
        }
    },
    data: function () {
        return {
            loading: false,
            form: {
                name: '',
                address: '',
                phone: ''
            }
        }
    },
    computed: {
        valid_form: function () {
            return this.form.name.length >= 2 &&
                this.form.name.length <= 30
        }
    },
    watch: {
        location: function () {
            if (this.location && this.location.id) {
                this.form.name = this.location.name
                this.form.address = this.location.address
                this.form.phone = this.location.phone
            } else {
                this.form.name = ''
                this.form.address = ''
                this.form.phone = ''
            }
        }
    },
    methods: {
        cancel: async function () {
            this.$bus.$emit('Modal/hide/manage-inventory-location')
        },
        submit: async function () {
            this.loading = true

            const payload = {
                name: this.form.name,
                address: this.form.address,
                phone: this.form.phone
            }

            let response = null
            if (this.location && this.location.id) {
                response = await InventoryLocationStore.dispatch('UPDATE', {
                    id: this.location.id,
                    params: payload
                })
            } else {
                response = await InventoryLocationStore.dispatch('CREATE', payload)
            }

            if (response.status === 200) {
                this.$bus.$emit('Modal/hide/manage-inventory-location')
                this.form.name = ''
                this.form.address = ''
                this.form.phone = ''
                this.$bus.$emit('Notification/show', { title: this.$t('notifications.operation_success'), msg: this.$t('notifications.operation_success_description'), level: 'success' })
            } else if (response.status === 409) {
                if (response.data.status === 1) {
                    this.$bus.$emit('Notification/show', { title: this.$t('management_console.workplace_modal.limit_title'), msg: this.$t('management_console.workplace_modal.limit_description'), level: 'danger' })
                } else {
                    this.$bus.$emit('Notification/show', { title: this.$t('management_console.workplace_modal.exists_title'), msg: this.$t('management_console.workplace_modal.exists_description'), level: 'danger' })
                }
            } else {
                this.$bus.$emit('Notification/show', { title: this.$t('notifications.something_went_wrong'), msg: this.$t('notifications.please_retry_the_operation_or_refresh'), level: 'danger' })
            }

            this.loading = false
        }
    }
}
</script>
